var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "540pt",
    height: "540pt",
    viewBox: "0 0 540 540",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 142 17 L 392 17 L 392 160 L 142 160 Z M 142 17 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 156.441406 0 L 369.128906 0 L 462.839844 175.148438 L 199.21875 316.179688 L 58.1875 52.558594 Z M 156.441406 0 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 199.21875 316.179688 L 58.183594 52.558594 L 321.804688 -88.476562 L 462.839844 175.144531 Z M 199.21875 316.179688 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 364.167969 398.558594 L 364.167969 188.816406 L 433.9375 188.816406 L 433.9375 253.589844 L 503.707031 253.589844 L 503.707031 398.558594 Z M 450.683594 196.53125 L 485.566406 235.085938 L 450.683594 235.085938 Z M 450.683594 170.3125 L 347.421875 170.3125 L 347.421875 417.066406 L 520.453125 417.066406 L 520.453125 238.167969 Z M 450.683594 170.3125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 380.910156 296.773438 L 486.960938 296.773438 L 486.960938 284.433594 L 380.910156 284.433594 Z M 380.910156 296.773438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 380.910156 272.097656 L 417.191406 272.097656 L 417.191406 259.761719 L 380.910156 259.761719 Z M 380.910156 272.097656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 380.910156 321.449219 L 486.960938 321.449219 L 486.960938 309.109375 L 380.910156 309.109375 Z M 380.910156 321.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 380.910156 346.125 L 486.960938 346.125 L 486.960938 333.785156 L 380.910156 333.785156 Z M 380.910156 346.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 380.910156 370.800781 L 486.960938 370.800781 L 486.960938 358.460938 L 380.910156 358.460938 Z M 380.910156 370.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 272.703125 249.019531 L 261.988281 244.59375 L 261.988281 244.578125 L 258.136719 242.984375 C 260.234375 238.039062 262.363281 232.945312 264.527344 227.714844 L 266.882812 222.015625 L 96.503906 151.566406 L 94.144531 157.269531 C 62.335938 234.203125 37.898438 279.453125 17.1875 299.671875 L 10.492188 306.210938 L 37.28125 317.285156 L 33.660156 326.042969 L 33.597656 326.011719 L 30.113281 334.457031 L 40.558594 362.078125 L 218.316406 435.574219 L 284.664062 275.109375 Z M 32.105469 301.792969 C 52.15625 278.660156 74.488281 236.480469 103.191406 167.679688 L 250.765625 228.699219 C 221.519531 298.78125 198.558594 341.609375 178.992188 362.523438 Z M 48.695312 322 L 181.890625 377.074219 L 184.796875 374.230469 C 204.417969 355.054688 225.882812 317.585938 253.273438 254.328125 L 258.90625 256.65625 L 201.53125 395.453125 L 45.070312 330.753906 Z M 211.632812 419.46875 L 50.210938 352.714844 L 47.304688 345.027344 L 208.214844 411.558594 L 267.699219 267.707031 L 271.207031 275.363281 Z M 211.632812 419.46875 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 142.273438 143.828125 C 142.273438 143.828125 186.003906 79.890625 311.28125 118.070312 L 298.917969 159.636719 L 391.300781 110.210938 L 341.875 17.820312 L 330.25 56.195312 C 329.832031 56.066406 207.257812 30.773438 142.273438 143.828125 Z M 142.273438 143.828125 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSummary);
export default __webpack_public_path__ + "static/media/Icon-Summary.42a2682089850f7448e2853ce41ab6d1.svg";
export { ForwardRef as ReactComponent };